import React from "react";
import "../../styles/ComparisonTable.css";
import { Link } from "react-router-dom";

const ComparisonTable = () => {
  return (
    <section className="comparison">
      <div className="table-scroll">
      <div className="table-container">

        {/* HEADER */}
        <div className="table-header">
          <div className="col title">WHAT YOU NEED</div>
          <div className="col highlights">
            <h4>FNBDATALAB</h4>
            <span className="caa">Operating Partner</span>
            <span className="tag">RECOMMENDED</span>
          </div>
          <div className="col">Consultant<br />
            <span className="caa">Advise & report</span>
          </div>
          <div className="col">Software / POS<br />
            <span className="caa">Data & dashboards</span>
          </div>
          <div className="col">Trainer / Coach<br />
            <span className="caa">Skills & mindset</span>
          </div>
        </div>

        {/* SECTION 1 */}
        <div className="sectio-title">01 — DIAGNOSIS & CLARITY</div>

        <div className="row">
          <div className="col title"><b>
            Diagnose what’s actually broken</b>
            <span>Root causes — not symptoms</span>
          </div>
          <div className="col"><span className="pill good">✦ Deep & structured</span>
          </div>
          <div className="col"><span className="pill warn">~ Sometimes</span><br />
          <span className="ca"> Surface-level only</span> </div>
          <div className="col"><span className="pill bad">✕ No</span><br />
          <span className="ca">Reports data</span></div>
          <div className="col"><span className="pill bad">✕No</span><br />
          <span className="ca">Not in scope</span></div>
        </div>

        <div className="row">
          <div className="col title"><b>
            Finds hidden margin leaks</b>
            <span>Food cost, process waste, vendors</span>
          </div>
          <div className="col"><span className="pill good">✦ Core deliverable</span></div>
          <div className="col"><span className="pill warn">~ Rarely</span></div>
          <div className="col"><span className="pill warn">~ Shows numbers</span><br />
          <span className="ca">You interprer</span></div>
          <div className="col"><span className="pill bad">✕ No</span></div>
        </div>

        {/* SECTION 2 */}
        <div className="sectio-title">02 — IMPLEMENTATION & EXECUTION</div>

        <div className="row">
          <div className="col title"><b>Actually builds — not just advises</b>
            <span>Systems inside your real business</span>
          </div>
          <div className="col"><span className="pill good">✦ Always</span></div>
          <div className="col"><span className="pill bad">✕ Advice only</span></div>
          <div className="col"><span className="pill bad">✕ You configure</span></div>
          <div className="col"><span className="pill warn">~ Training only</span></div>
        </div>

        <div className="row">
          <div className="col title"><b>Embeds SOPs into daily execution</b>
            <span>Team follows without you present</span>
          </div>
          <div className="col"><span className="pill good">✦ Fully embedded</span></div>
          <div className="col"><span className="pill bad">✕ Leaves a doc</span></div>
          <div className="col"><span className="pill bad">✕ No</span></div>
          <div className="col"><span className="pill warn">~ Partially</span></div>
        </div>
        <div className="row">
          <div className="col title"><b>Covers all 8 operating disciplines</b>
            <span>Cost, kitchen, people, compliance, tech, supply, digital, performance</span>
          </div>
          <div className="col"><span className="pill good">✦ End-to-end</span></div>
          <div className="col"><span className="pill bad">✕ Narrow scope</span></div>
          <div className="col"><span className="pill bad">✕ Tech only</span></div>
          <div className="col"><span className="pill warn">✕ People only</span></div>
        </div>

        {/* SECTION 3 */}
        <div className="sectio-title">03 — ACCOUNTABILITY & PARTNERSHIP
          
        </div>

        <div className="row">
          <div className="col title"><b>Stays until it holds under pressure</b>
            <span>Accountable for outcomes — not time</span>
          </div>
          <div className="col"><span className="pill good">✦ Our standard</span></div>
          <div className="col"><span className="pill bad">✕ Contract ends</span></div>
          <div className="col"><span className="pill bad">✕ Subscription</span></div>
          <div className="col"><span className="pill bad">✕ Session-based</span></div>
        </div>

        <div className="row">
          <div className="col title"><b>20+ years F&B operations experience</b>
            <span>Kitchens, chains, multi-outlet — not theory</span>
          </div>
          <div className="col"><span className="pill good">✦ Built into our DNA</span></div>
          <div className="col"><span className="pill warn">~ Often generic</span></div>
          <div className="col"><span className="pill bad">✕ Product company</span></div>
          <div className="col"><span className="pill warn">~ Varies widely</span></div>
        </div>

        {/* SECTION 4 */}
        <div className="sectio-title">04 — OUTCOMES THAT CHANGE THE BUSINESS</div>

        <div className="row">
          <div className="col title"><b>Reduces founder dependency</b>
            <span>Business runs when you're not in the room</span>
          </div>
          <div className="col"><span className="pill good">✦ Primary goal</span></div>
          <div className="col"><span className="pill bad">✕ Not addressed</span></div>
          <div className="col"><span className="pill bad">✕ No</span></div>
          <div className="col"><span className="pill warn">~ Partially</span></div>
        </div>

        <div className="row">
          <div className="col title"><b>Low-risk entry point</b>
            <span>Diagnostic first — no retainer upfront</span>
          </div>
          <div className="col"><span className="pill good">✦ ₹15K–₹20K</span></div>
          <div className="col"><span className="pill bad">✕ High retainers</span></div>
          <div className="col"><span className="pill warn">~ SaaS plans</span></div>
          <div className="col"><span className="pill warn">~  Per session</span></div>
        </div>

        {/* FOOTER */}
        <div className="table-footer">
          <p><b>
            "We don’t stand outside giving opinions. We work inside — building how your restaurant runs."</b>
          </p>
          <Link to="/contact" className="btn-2">
                    Book a Fit Call
                  </Link>
        </div>
      </div>
      </div>
    </section>
  );
};

export default ComparisonTable;